import { ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { useStyles } from './sign-up-banner.styles';
import { Button } from '../../../../common/button-new';
import { InternalLinks } from '../../../../../constants';
import { getDayPeriod } from './time-based-images';
import { useDayPeriodResponsiveImage } from '../../../../../hooks/use-day-period-responsive-image';
import { v2026PP10981 } from '../../../../../constants/veeva';
import { Veeva } from '../../../../common/veeva';

export const SignUpBanner = (): JSX.Element => {
  const intl = useIntl();
  const classes = useStyles();
  const dayPeriod = getDayPeriod();
  const selectedSrc = useDayPeriodResponsiveImage();

  return (
    <div
      className={classes.root}
      data-testid="slide"
      style={{ backgroundImage: selectedSrc ? `url('${selectedSrc}')` : undefined }}
    >
      <div className={classes.inner}>
        <div className={classes.content} data-testid="slide-content">
          <h1 className={classes.title} data-testid="title">
            {intl.formatMessage({
              id:
                dayPeriod === 'morning'
                  ? 'signUpBanner.morning.title'
                  : dayPeriod === 'afternoon'
                    ? 'signUpBanner.afternoon.title'
                    : 'signupBanner.evening.title',
            })}
          </h1>
          <p className={classes.text}>
            {intl.formatMessage(
              { id: 'signUpBanner.title' },
              {
                span: (chunks: ReactNode) => <span className={classes.newLine}>{chunks}</span>,
                sup: (chunks: ReactNode) => <sup>{chunks}</sup>,
              },
            )}
          </p>
          <Button rootClasses={classes.button} data-testid="signup-button" to={InternalLinks.ecpLocator} style="light">
            <FormattedMessage id="signUpBanner.button" />
          </Button>
        </div>
      </div>
      <div className={classes.veevaContainer}>
        <Veeva veevaNumber={v2026PP10981} isRight></Veeva>
      </div>
    </div>
  );
};
